export default __webpack_public_path__ + "static/media/bg.a3e69fc5.jpg";